const EMPLOYEE_REHIRE_TABLE_READY = "employeeRehire-table-ready"
const SEARCH_TEXT_STATE = "employeeRehire-table-search-text-state"
const ROWS_PER_PAGE_STATE = "employeeRehire-table-rows-per-page-state"
const PAGINATION_STATE = "employeeRehire-table-pagination-state"

const EMPLOYEE_REHIRE_ID_FOR_ACTION = "employeeRehire-table-employee-rehire-id-for-action"

const ADD_EMPLOYEE_REHIRE_READY = "eemployeeRehire-table-add-employee-rehire-ready"

const PREVIOUS_EMPLOYEE_REHIRE_FILTER_CITY = "previous-employee-rehire-filter-city"

const PREVIOUS_EMPLOYEE_REHIRE_FILTER_KITCHEN_ID = "previous-employee-rehire-filter-kitchen-id-action"

const PREVIOUS_EMPLOYEE_REHIRE_FILTER_START_DATE= "previous-employee-rehire-filter-start-date"
const PREVIOUS_EMPLOYEE_REHIRE_FILTER_END_DATE= "previous-employee-rehire-filter-end-date"



const initialState = {
    isEmployeeRehireTableReady: true,
    isAddEmployeeRehireReady:true,
    employeeRehire: {},
    
    employeeRehireSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterCity : "",
    previousFilterKitchenId : "",
    previousFilterStartDate : "",
    previousFilterEndDate : "",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case EMPLOYEE_REHIRE_TABLE_READY:
            return Object.assign({}, state, { isEmployeeRehireTableReady: action.payload })
        case ADD_EMPLOYEE_REHIRE_READY:
            return Object.assign({}, state, { isAddEmployeeRehireReady: action.payload })


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case EMPLOYEE_REHIRE_ID_FOR_ACTION:
            return Object.assign({}, state, {employeeRehireSelectedId:action.payload})

        case PREVIOUS_EMPLOYEE_REHIRE_FILTER_CITY:
            return Object.assign({}, state, {previousFilterCity:action.payload})

        case PREVIOUS_EMPLOYEE_REHIRE_FILTER_KITCHEN_ID:
            return Object.assign({}, state, {previousFilterKitchenId:action.payload})

        case PREVIOUS_EMPLOYEE_REHIRE_FILTER_START_DATE:
            return Object.assign({}, state, {previousFilterStartDate:action.payload})

        case PREVIOUS_EMPLOYEE_REHIRE_FILTER_END_DATE:
            return Object.assign({}, state, {previousFilterEndDate:action.payload})

        default:
        return state
    
    }

}

export function employeeRehireTableReady(data) {
    return {
        type: EMPLOYEE_REHIRE_TABLE_READY,
        payload: data
    }
}


export function addEmployeeRehireReady(data) {
    return {
        type: ADD_EMPLOYEE_REHIRE_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function employeeRehireIdForAction(employeeRehireId){
    return{
        type:EMPLOYEE_REHIRE_ID_FOR_ACTION,
        payload:employeeRehireId
    }
}

export function previousFilterCity(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_REHIRE_FILTER_CITY,
        payload:filterVal
    }
}


export function previousFilterKitchenId(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_REHIRE_FILTER_KITCHEN_ID,
        payload:filterVal
    }
}


export function previousFilterStartDate(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_REHIRE_FILTER_START_DATE,
        payload:filterVal
    }
}


export function previousFilterEndDate(filterVal){
    return{
        type:PREVIOUS_EMPLOYEE_REHIRE_FILTER_END_DATE,
        payload:filterVal
    }
}




// WEBPACK FOOTER //
// ./src/modules/Employee Rehire/redux/employee_rehire.js